import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteProduct } from '../services/products.api';

export function useDeleteProduct() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteProduct(id),
    onSuccess: (_data, id) => {
      void queryClient.invalidateQueries({ queryKey: ['products', 'list'] });
      void queryClient.removeQueries({ queryKey: ['products', 'detail', id] });
    },
  });
}
